module.exports = __webpack_public_path__ + "img/ctji.cb502cf3.jpg";